<h1 mat-dialog-title>{{'SCORE_PAGE.LOCK_DIALOG.WARNING' | translate}}</h1>
<div mat-dialog-content>
  <p>{{'SCORE_PAGE.LOCK_DIALOG.MESSAGE' | translate}}</p>
</div>
<div mat-dialog-actions>
    <button 
        mat-raised-button color="primary"  class="btn-return"
        cdkFocusInitial
        (click)="dialogRef.close(false)">
        {{'SCORE_PAGE.LOCK_DIALOG.NO' | translate}}
    </button>
    <button 
        mat-raised-button color="primary"
        (click)="dialogRef.close(true)">
        {{'SCORE_PAGE.LOCK_DIALOG.YES' | translate}}
    </button>
</div>
